import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoContrattiDaFornitoreStep2Component
} from './conservazione-carica-documento-contratti-da-fornitore-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.conservazione-carica-documento-contratti-da-fornitore-step2', {
      url: '/conservazione-carica-documento-contratti-da-fornitore',
      ncyBreadcrumb: {
        label: 'Carica Contratti da Fornitore',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      'views': {
        'homeContent': {
          template: '<conservazione-carica-documento-contratti-da-fornitore-step2 flex="100"></conservazione-carica-documento-contratti-da-fornitore-step2>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoContrattiDaFornitoreStep2Module: string = ng
  .module('conservazione-carica-documento-contratti-da-fornitore-step2', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('conservazioneCaricaDocumentoContrattiDaFornitoreStep2', ConservazioneCaricaDocumentoContrattiDaFornitoreStep2Component)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-contratti-da-fornitore-step2/conservazione-carica-documento-contratti-da-fornitore-step2.module.ts